import Component from '@galactic-advisors/component-loader';
import DataTable from 'datatables.net-bs4';

const DEFAULTS = {
  dataTableElement: '[data-datatable-element]',
};

export default class Datatable extends Component {
  static selector = '[data-comp-datatable]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.initDatatable();
  }

  initDatatable() {
    const datatable = new DataTable(
      this.$container.querySelector(this.$options.dataTableElement),
      {
        order: [[1, 'desc']],
      }
    );
    return datatable;
  }
}
